'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var Q = require('q');  /* jshint ignore:line */
var _ = require('lodash');  /* jshint ignore:line */
var util = require('util');  /* jshint ignore:line */
var NetworkAccessProfileNetworkList = require(
    './networkAccessProfile/networkAccessProfileNetwork').NetworkAccessProfileNetworkList;
var Page = require('../../../base/Page');  /* jshint ignore:line */
var deserialize = require(
    '../../../base/deserialize');  /* jshint ignore:line */
var serialize = require('../../../base/serialize');  /* jshint ignore:line */
var values = require('../../../base/values');  /* jshint ignore:line */

var NetworkAccessProfileList;
var NetworkAccessProfilePage;
var NetworkAccessProfileInstance;
var NetworkAccessProfileContext;

/* jshint ignore:start */
/**
 * Initialize the NetworkAccessProfileList
 *
 * PLEASE NOTE that this class contains beta products that are subject to change.
 * Use them with caution.
 *
 * @constructor Twilio.Supersim.V1.NetworkAccessProfileList
 *
 * @param {Twilio.Supersim.V1} version - Version of the resource
 */
/* jshint ignore:end */
NetworkAccessProfileList = function NetworkAccessProfileList(version) {
  /* jshint ignore:start */
  /**
   * @function networkAccessProfiles
   * @memberof Twilio.Supersim.V1#
   *
   * @param {string} sid - sid of instance
   *
   * @returns {Twilio.Supersim.V1.NetworkAccessProfileContext}
   */
  /* jshint ignore:end */
  function NetworkAccessProfileListInstance(sid) {
    return NetworkAccessProfileListInstance.get(sid);
  }

  NetworkAccessProfileListInstance._version = version;
  // Path Solution
  NetworkAccessProfileListInstance._solution = {};
  NetworkAccessProfileListInstance._uri = `/NetworkAccessProfiles`;
  /* jshint ignore:start */
  /**
   * create a NetworkAccessProfileInstance
   *
   * @function create
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.uniqueName] -
   *          An application-defined string that uniquely identifies the resource
   * @param {string|list} [opts.networks] -
   *          List of Network SIDs that this Network Access Profile will allow connections to
   * @param {function} [callback] - Callback to handle processed record
   *
   * @returns {Promise} Resolves to processed NetworkAccessProfileInstance
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.create = function create(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'UniqueName': _.get(opts, 'uniqueName'),
      'Networks': serialize.map(_.get(opts, 'networks'), function(e) { return e; })
    });

    var promise = this._version.create({uri: this._uri, method: 'POST', data: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new NetworkAccessProfileInstance(this._version, payload, this._solution.sid));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Streams NetworkAccessProfileInstance records from the API.
   *
   * This operation lazily loads records as efficiently as possible until the limit
   * is reached.
   *
   * The results are passed into the callback function, so this operation is memory
   * efficient.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function each
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         each() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no pageSize is defined but a limit is defined,
   *         each() will attempt to read the limit with the most efficient
   *         page size, i.e. min(limit, 1000)
   * @param {Function} [opts.callback] -
   *         Function to process each record. If this and a positional
   *         callback are passed, this one will be used
   * @param {Function} [opts.done] -
   *          Function to be called upon completion of streaming
   * @param {Function} [callback] - Function to process each record
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.each = function each(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    if (opts.callback) {
      callback = opts.callback;
    }
    if (_.isUndefined(callback)) {
      throw new Error('Callback function must be provided');
    }

    var done = false;
    var currentPage = 1;
    var currentResource = 0;
    var limits = this._version.readLimits({
      limit: opts.limit,
      pageSize: opts.pageSize
    });

    function onComplete(error) {
      done = true;
      if (_.isFunction(opts.done)) {
        opts.done(error);
      }
    }

    function fetchNextPage(fn) {
      var promise = fn();
      if (_.isUndefined(promise)) {
        onComplete();
        return;
      }

      promise.then(function(page) {
        _.each(page.instances, function(instance) {
          if (done || (!_.isUndefined(opts.limit) && currentResource >= opts.limit)) {
            done = true;
            return false;
          }

          currentResource++;
          callback(instance, onComplete);
        });

        if (!done) {
          currentPage++;
          fetchNextPage(_.bind(page.nextPage, page));
        } else {
          onComplete();
        }
      });

      promise.catch(onComplete);
    }

    fetchNextPage(_.bind(this.page, this, _.merge(opts, limits)));
  };

  /* jshint ignore:start */
  /**
   * Lists NetworkAccessProfileInstance records from the API as a list.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function list
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         list() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no page_size is defined but a limit is defined,
   *         list() will attempt to read the limit with the most
   *         efficient page size, i.e. min(limit, 1000)
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.list = function list(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    var deferred = Q.defer();
    var allResources = [];
    opts.callback = function(resource, done) {
      allResources.push(resource);

      if (!_.isUndefined(opts.limit) && allResources.length === opts.limit) {
        done();
      }
    };

    opts.done = function(error) {
      if (_.isUndefined(error)) {
        deferred.resolve(allResources);
      } else {
        deferred.reject(error);
      }
    };

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    this.each(opts);
    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single page of NetworkAccessProfileInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function page
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.pageToken] - PageToken provided by the API
   * @param {number} [opts.pageNumber] -
   *          Page Number, this value is simply for client state
   * @param {number} [opts.pageSize] - Number of records to return, defaults to 50
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.page = function page(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'PageToken': opts.pageToken,
      'Page': opts.pageNumber,
      'PageSize': opts.pageSize
    });

    var promise = this._version.page({uri: this._uri, method: 'GET', params: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new NetworkAccessProfilePage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single target page of NetworkAccessProfileInstance records from the
   * API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function getPage
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {string} [targetUrl] - API-generated URL for the requested results page
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.getPage = function getPage(targetUrl, callback)
                                                               {
    var deferred = Q.defer();

    var promise = this._version._domain.twilio.request({method: 'GET', uri: targetUrl});

    promise = promise.then(function(payload) {
      deferred.resolve(new NetworkAccessProfilePage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Constructs a network_access_profile
   *
   * @function get
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @param {string} sid - The SID that identifies the resource to fetch
   *
   * @returns {Twilio.Supersim.V1.NetworkAccessProfileContext}
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.get = function get(sid) {
    return new NetworkAccessProfileContext(this._version, sid);
  };

  /* jshint ignore:start */
  /**
   * Provide a user-friendly representation
   *
   * @function toJSON
   * @memberof Twilio.Supersim.V1.NetworkAccessProfileList#
   *
   * @returns Object
   */
  /* jshint ignore:end */
  NetworkAccessProfileListInstance.toJSON = function toJSON() {
    return this._solution;
  };

  NetworkAccessProfileListInstance[util.inspect.custom] = function inspect(depth,
      options) {
    return util.inspect(this.toJSON(), options);
  };

  return NetworkAccessProfileListInstance;
};


/* jshint ignore:start */
/**
 * Initialize the NetworkAccessProfilePage
 *
 * PLEASE NOTE that this class contains beta products that are subject to change.
 * Use them with caution.
 *
 * @constructor Twilio.Supersim.V1.NetworkAccessProfilePage
 *
 * @param {V1} version - Version of the resource
 * @param {Response<string>} response - Response from the API
 * @param {NetworkAccessProfileSolution} solution - Path solution
 *
 * @returns NetworkAccessProfilePage
 */
/* jshint ignore:end */
NetworkAccessProfilePage = function NetworkAccessProfilePage(version, response,
    solution) {
  // Path Solution
  this._solution = solution;

  Page.prototype.constructor.call(this, version, response, this._solution);
};

_.extend(NetworkAccessProfilePage.prototype, Page.prototype);
NetworkAccessProfilePage.prototype.constructor = NetworkAccessProfilePage;

/* jshint ignore:start */
/**
 * Build an instance of NetworkAccessProfileInstance
 *
 * @function getInstance
 * @memberof Twilio.Supersim.V1.NetworkAccessProfilePage#
 *
 * @param {NetworkAccessProfilePayload} payload - Payload response from the API
 *
 * @returns NetworkAccessProfileInstance
 */
/* jshint ignore:end */
NetworkAccessProfilePage.prototype.getInstance = function getInstance(payload) {
  return new NetworkAccessProfileInstance(this._version, payload);
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Supersim.V1.NetworkAccessProfilePage#
 *
 * @returns Object
 */
/* jshint ignore:end */
NetworkAccessProfilePage.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

NetworkAccessProfilePage.prototype[util.inspect.custom] = function
    inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the NetworkAccessProfileContext
 *
 * PLEASE NOTE that this class contains beta products that are subject to change.
 * Use them with caution.
 *
 * @constructor Twilio.Supersim.V1.NetworkAccessProfileInstance
 *
 * @property {string} sid - The unique string that identifies the resource
 * @property {string} uniqueName -
 *          An application-defined string that uniquely identifies the resource
 * @property {string} accountSid -
 *          The SID of the Account that the Network Access Profile belongs to
 * @property {Date} dateCreated -
 *          The ISO 8601 date and time in GMT when the resource was created
 * @property {Date} dateUpdated -
 *          The ISO 8601 date and time in GMT when the resource was last updated
 * @property {string} url - The absolute URL of the resource
 * @property {string} links - The links
 *
 * @param {V1} version - Version of the resource
 * @param {NetworkAccessProfilePayload} payload - The instance payload
 * @param {sid_like} sid - The SID that identifies the resource to fetch
 */
/* jshint ignore:end */
NetworkAccessProfileInstance = function NetworkAccessProfileInstance(version,
    payload, sid) {
  this._version = version;

  // Marshaled Properties
  this.sid = payload.sid; // jshint ignore:line
  this.uniqueName = payload.unique_name; // jshint ignore:line
  this.accountSid = payload.account_sid; // jshint ignore:line
  this.dateCreated = deserialize.iso8601DateTime(payload.date_created); // jshint ignore:line
  this.dateUpdated = deserialize.iso8601DateTime(payload.date_updated); // jshint ignore:line
  this.url = payload.url; // jshint ignore:line
  this.links = payload.links; // jshint ignore:line

  // Context
  this._context = undefined;
  this._solution = {sid: sid || this.sid, };
};

Object.defineProperty(NetworkAccessProfileInstance.prototype,
  '_proxy', {
    get: function() {
      if (!this._context) {
        this._context = new NetworkAccessProfileContext(this._version, this._solution.sid);
      }

      return this._context;
    }
});

/* jshint ignore:start */
/**
 * fetch a NetworkAccessProfileInstance
 *
 * @function fetch
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed NetworkAccessProfileInstance
 */
/* jshint ignore:end */
NetworkAccessProfileInstance.prototype.fetch = function fetch(callback) {
  return this._proxy.fetch(callback);
};

/* jshint ignore:start */
/**
 * update a NetworkAccessProfileInstance
 *
 * @function update
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileInstance#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.uniqueName] - The new unique name of the resource
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed NetworkAccessProfileInstance
 */
/* jshint ignore:end */
NetworkAccessProfileInstance.prototype.update = function update(opts, callback)
    {
  return this._proxy.update(opts, callback);
};

/* jshint ignore:start */
/**
 * Access the networks
 *
 * @function networks
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileInstance#
 *
 * @returns {Twilio.Supersim.V1.NetworkAccessProfileContext.NetworkAccessProfileNetworkList}
 */
/* jshint ignore:end */
NetworkAccessProfileInstance.prototype.networks = function networks() {
  return this._proxy.networks;
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileInstance#
 *
 * @returns Object
 */
/* jshint ignore:end */
NetworkAccessProfileInstance.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

NetworkAccessProfileInstance.prototype[util.inspect.custom] = function
    inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the NetworkAccessProfileContext
 *
 * PLEASE NOTE that this class contains beta products that are subject to change.
 * Use them with caution.
 *
 * @constructor Twilio.Supersim.V1.NetworkAccessProfileContext
 *
 * @property {Twilio.Supersim.V1.NetworkAccessProfileContext.NetworkAccessProfileNetworkList} networks -
 *          networks resource
 *
 * @param {V1} version - Version of the resource
 * @param {sid_like} sid - The SID that identifies the resource to fetch
 */
/* jshint ignore:end */
NetworkAccessProfileContext = function NetworkAccessProfileContext(version, sid)
    {
  this._version = version;

  // Path Solution
  this._solution = {sid: sid, };
  this._uri = `/NetworkAccessProfiles/${sid}`;

  // Dependents
  this._networks = undefined;
};

/* jshint ignore:start */
/**
 * fetch a NetworkAccessProfileInstance
 *
 * @function fetch
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed NetworkAccessProfileInstance
 */
/* jshint ignore:end */
NetworkAccessProfileContext.prototype.fetch = function fetch(callback) {
  var deferred = Q.defer();
  var promise = this._version.fetch({uri: this._uri, method: 'GET'});

  promise = promise.then(function(payload) {
    deferred.resolve(new NetworkAccessProfileInstance(this._version, payload, this._solution.sid));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * update a NetworkAccessProfileInstance
 *
 * @function update
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileContext#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.uniqueName] - The new unique name of the resource
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed NetworkAccessProfileInstance
 */
/* jshint ignore:end */
NetworkAccessProfileContext.prototype.update = function update(opts, callback) {
  if (_.isFunction(opts)) {
    callback = opts;
    opts = {};
  }
  opts = opts || {};

  var deferred = Q.defer();
  var data = values.of({'UniqueName': _.get(opts, 'uniqueName')});

  var promise = this._version.update({uri: this._uri, method: 'POST', data: data});

  promise = promise.then(function(payload) {
    deferred.resolve(new NetworkAccessProfileInstance(this._version, payload, this._solution.sid));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

Object.defineProperty(NetworkAccessProfileContext.prototype,
  'networks', {
    get: function() {
      if (!this._networks) {
        this._networks = new NetworkAccessProfileNetworkList(this._version, this._solution.sid);
      }
      return this._networks;
    }
});

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Supersim.V1.NetworkAccessProfileContext#
 *
 * @returns Object
 */
/* jshint ignore:end */
NetworkAccessProfileContext.prototype.toJSON = function toJSON() {
  return this._solution;
};

NetworkAccessProfileContext.prototype[util.inspect.custom] = function
    inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};

module.exports = {
  NetworkAccessProfileList: NetworkAccessProfileList,
  NetworkAccessProfilePage: NetworkAccessProfilePage,
  NetworkAccessProfileInstance: NetworkAccessProfileInstance,
  NetworkAccessProfileContext: NetworkAccessProfileContext
};
